import React, { Component } from "react";
import { 
    Button,
    Intent,
    Card, 
    FormGroup,
    InputGroup,
    Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import DeviceIdTable from "./DeviceIdTable"
import { EacAuthenticatedGetFetch, EacAuthenticatedPutFetch } from "../../utils/ExternalAccessControlAuthenticatedFetch";



export default class OPnGOPage extends Component {
    constructor() {
        super();
        this.state = {
            baseUrl: "",
            partnerId: "",
            apiKey: "",
            pwd: "",
            profileId: 0
        };        
    }

    componentDidMount() {
        EacAuthenticatedGetFetch('/opngo/config', (data)=>{
            const ret = {baseUrl: "", partnerId: "", apiKey: "", pwd: "", profileId: 0}
            if(data.baseUrl)
                ret.baseUrl = data.baseUrl;
            if(data.partnerId)
                ret.partnerId = data.partnerId;
            if(data.apiKey)
                ret.apiKey = data.apiKey;
            if(data.pwd)
                ret.pwd = data.pwd;
            if(data.profileId)
                ret.profileId = data.profileId;
            
            this.setState(ret);
        });       
    }
    disableSaveButton(){
        return !(this.state.baseUrl.length > 0 
            &&  this.state.partnerId.length > 0
            &&  this.state.apiKey.length > 0
            &&  this.state.pwd.length > 0
            &&  this.state.profileId > 0);
    }
    saveConfig() {
        EacAuthenticatedPutFetch('/opngo/config', this.state, (data)=>{

        });
    }


    render() {
        return (
          <div>
            <Callout  title={<Trans>Configuration</Trans>}>
              <Card>
                  <form>
                    <FormGroup label={<Trans>external bo url</Trans>} labelFor="ex-bo-url-input">
                      <InputGroup id="ex-bo-url-input"
                        onChange={(ti) => { this.setState({ baseUrl: ti.target.value }); }}
                        value={this.state.baseUrl}
                        intent="normal"
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>partner ID</Trans>} labelFor="partnerId-input">
                      <InputGroup
                        id="partnerId-input"
                        type="text"
                        onChange={(ti) => { this.setState({ partnerId: ti.target.value }); }}
                        value={this.state.partnerId}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>api Key</Trans>} labelFor="apiKey-input">
                      <InputGroup
                        id="apiKey-input"
                        type="text"
                        onChange={(ti) => { this.setState({ apiKey: ti.target.value }); }}
                        value={this.state.apiKey}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>password</Trans>} labelFor="pwd-input">
                      <InputGroup
                        id="pwd-input"
                        type="text"
                        onChange={(ti) => { this.setState({ pwd: ti.target.value }); }}
                        value={this.state.pwd}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>profile</Trans>} labelFor="profileId-input">
                      <InputGroup
                        id="profileId-input"
                        type="number"
                        onChange={(ti) => { this.setState({ profileId: ti.target.value }); }}
                        value={this.state.profileId}
                        intent="normal"
                      />
                    </FormGroup>
                  </form>
                  <div className="flexbox-right">
                    <Button
                        text={<Trans>edit</Trans>}
                        icon="send-to"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={this.disableSaveButton()}
                        onClick={() => { this.saveConfig()}}
                        />
                  </div>
              </Card>
            </Callout>
            <Callout  title={<Trans>settings</Trans>}>
                  <DeviceIdTable target="opngo"></DeviceIdTable>
            </Callout>
          </div>
        );
    }
}
